<template>
    <div class="explore">
        <img src="imgs/explore/banner.png" alt="" style="margin-bottom: 20px;width:1024px">
        <ul class="electiveBox">
            <li v-for="(item,index) in cdata">
                <div class="item_logo">
                    <img :src="item.src"/>
                </div>
                <div class="item_title">{{item.title}}</div>
                <div class="item_text">{{item.content}}</div>
                <div class="button" @click="jump(item.link)">{{item.button}}</div>
                <!-- <div class="left">
                    <img :src="item.src" alt="">
                </div> -->
                <!-- <div class="right">
                    <div class="title">
                        {{item.title}}
                    </div>
                    <p v-html="item.content">
                    </p>
                    <div class="button" @click="jump(item.link)">
                        {{item.button}}
                    </div>
                </div> -->
            </li>
            <li>
                <img src="/imgs/selfAssessment/come_icon.svg" class="come_icon"/><br/>
                <p class="come_text">敬请期待</p>
            </li>
            <!-- <li>敬请期待</li> -->
        </ul>
        <!-- <div class="myReports">
            <div class="title">
                <img src="imgs/careerArchives/icon_biaoti.png" alt="">
                新高考资讯
            </div>
            <ul class="list">
                <li v-for="item in lists" v-if="item.pic">
                    <img :src="item.pic" alt="" class="img">
                    <div class="right">
                        <p @click="getJump(item.id)">{{item.title}}</p>
                        <div>
                            <img src="imgs/explore/icon_clock.png" alt="">
                            <span>{{item.date}}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div> -->
    </div>
</template>
<script>
    export default {
        name: "",
        data(){
            return{
                cdata:[
                    {
                        src:"/imgs/explore/icon_zhuanyeku2.png",
                        title:"专业库",
                        content:"本科和高职专科所有专业信息",
                        button:"查看",
                        link:"/explore/zhuanyeku"
                    },
                    {
                        src:"/imgs/explore/icon_yuanxiaoku2.png",
                        title:"院校库",
                        content:"教育部公布的所有大学数据及其信息",
                        button:"查看",
                        link:"/explore/yuanxiaoku"
                    },
                    {
                        src:"/imgs/explore/icon_zhiyeku2.png",
                        title:"职业库",
                        content:"涵盖职业分类大典海量数据信息",
                        button:"查看",
                        link:"/explore/zhiyeku"
                    },
                    {
                        src:"/imgs/explore/icon_xuekepinggu.png",
                        title:"学科评估",
                        content:"全国第四轮学科评估结果",
                        button:"查看",
                        link:"/explore/xuekepinggu/xuekesubject"
                    },
                    // {
                    //     src:"/imgs/explore/icon_zizhaoyuanxiaoku2.png",
                    //     title:"强基院校库",
                    //     content:"尽收强基院校及信息",
                    //     button:"查看",
                    //     link:"/explore/zizhaoyuanxiaoku"
                    // },
                    {
                        src:"/imgs/explore/icon_wodeshoucang2.png",
                        title:"高考百科",
                        content:"各类隐藏知识点一网打尽",
                        button:"查看",
                        link:"/explore/gaokaobaike"
                    },
                    {
                        src:"/imgs/explore/icon_wodeshoucang2.png",
                        title:"高中竞赛库",
                        content:"高中竞赛知识需知",
                        button:"查看",
                        link:"/explore/myCollection"
                    },
                    
                ],
                lists:[]
            }
        },
        methods:{
            //跳转页面
            jump(path){
                this.$router.push(path)
            },
            //资讯列表
            list(){
                let _this=this;
                this.$ajax.post(this.G_uri+this.ports.information.list,{
                    cateId:12
                },{
                    headers:{
                        token:window.sessionStorage.getItem('ymtxToken')
                    }
                }).then(res=>{
                    if(res.data.code==2000){
                        _this.lists=res.data.data.list;
                    }
                })
            },
            //资讯跳转详情
            getJump(id){
                this.$ajax.post(this.G_uri+this.ports.information.clickNum,{
                    id:id
                }).then(function (res) {
                })
                this.$router.push({
                    path:'/explore/informationDetail',
                    query:{
                        id:id
                    }
                })
            }

        },
        mounted(){
            this.list();
            let _this = this;                 
            // this.getVersion() ;  
           
            this.$ajax.post(this.G_uri + '/powerTech/check', {
                  route:'/explore/main'
                },{
                    headers: {
                        token: window.sessionStorage.getItem("ymtxToken")
                    }
                }).then(res=>{
                    // console.log(res,'返回判断有没有当前地址')
                    if(res.data.code == 2000){

                    }else{
                        this.$router.push('/NotFind')
                    }
                })  
        }
    }
</script>
<style scoped lang="less"> 
    .come_icon{
       width: 72px;
    height: 72px;
    margin: 30px auto 0px !important;
    display: block;
   }
   .come_text{
       text-align: center;
       line-height: 38px;
       color: #bfbfbf;;
       font-size:24px;
   }
    .explore{
        padding-left: 20px;
        width: 1024px !important;
        *{
            box-sizing: border-box;
            letter-spacing: 1.5px;
        }
        width: 100%;
        padding-left: 20px;
        .electiveBox{
            background: #fff;
            // width: 970px;
            // height: 424px;
            // height: 536px;
            padding:10px;
            border-radius: 5px;
            display: flex;
            // justify-content:space-around;
            // justify-content: space-between;
            flex-wrap: wrap;
            padding: 20px 0px;
            background: #FFFFFF;
            li{
                position: relative;
                width: 322px;
                height: 195px;
                text-align: center;
                border: 1px solid #E9E9E9;
                box-sizing: border-box;     
                margin-bottom: 15px;   
                margin-left: 15px;       
            }
        }
    }
    .item_logo{
        margin: 13px 0 8px;
    }
    .item_title{
        font-weight: 600;
        color: #333333;
        line-height: 22px;
    }
    .item_text{
        font-weight: 600;
        color: rgba(51, 51, 51, 0.66);
        line-height: 38px;
        font-size: 14px;      
        font-family: 'PingFangSC-Semibold, PingFang SC';
    }
    .button{
        width: 80px;
        height: 28px;
        background: #3d90f6;
        border-radius: 5px;
        color: #fff;
        line-height: 28px;
        font-size: 14px;
        margin: auto;
        cursor: pointer;
    }
</style>

